import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/useHttp";
import { LOADS_LIST_GET_URL } from "../../../utils/api-ends";
import { Link } from "react-router-dom";
import LoaderImg from "../../../assets/media/loader.gif";

import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/utility/map.css";
import "../../../assets/css/create-load-post.css";
import "../../../assets/css/profile.page.css";
import "../../../assets/css/load-post-details-page.css";

const SipperLoadPostList = () => {
  const { isLoading, sendRequests } = useHttp();
  const { isLoading: seeMoreLoading, sendRequests: seeMoreRequests } =
    useHttp();

  const [loadPostList, setLoadPostList] = useState([]);
  const [nextPageNumber, setNextPageNumber] = useState("");

  useEffect(() => {
    const response = (data) => {
      setLoadPostList(data.data.results);
      setNextPageNumber(data.data.pagination.next_page_number);
    };

    // Send request to get shipper load list
    sendRequests(
      {
        url: LOADS_LIST_GET_URL(1),
        method: "GET",
      },
      response
    );
  }, []);

  //Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      nextPageNumber
    ) {
      const response = (data) => {
        // Update the shipper load list state
        setLoadPostList([...loadPostList, ...data.data.results]);
        const pageNumber =
          data.data.pagination.next_page_number != null
            ? data.data.pagination.next_page_number
            : "";
        setNextPageNumber(pageNumber);
      };

      // Send get request to get shipper load list
      seeMoreRequests(
        {
          url: LOADS_LIST_GET_URL(nextPageNumber),
          method: "GET",
        },
        response
      );
    }
  };

  return (
    <section>
      <div className="container theme-section">
        <h1 className="large-text text-center mb-4">Created Load Feed List</h1>
        <div className="carrier-offer-table-wrapper">
          <div className="carrier-offer-table">
            {isLoading ? (
              <div className="loader d-flex justify-content-center mb-5 mt-5">
                <img style={{ width: "35px" }} src={LoaderImg} alt="" />
              </div>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Destination State</th>
                    <th scope="col">Destination City</th>
                    <th scope="col">Destination Address</th>
                    <th scope="col">Load Type</th>
                    <th scope="col">Origin State</th>
                    <th scope="col">Origin City</th>
                    <th scope="col">Origin Address</th>
                    <th scope="col">Pickup Date </th>
                    <th scope="col">Delivery Date</th>
                    <th scope="col">Price</th>
                    <th scope="col">Status</th>
                    <th scope="col">Review</th>
                  </tr>
                </thead>
                <tbody>
                  {loadPostList?.length > 0 ? (
                    loadPostList?.map((value, index) => (
                      <tr>
                        <td>{value.destination_state}</td>
                        <td>{value.destination_city}</td>
                        <td>{value.destination_address}</td>
                        <td>{value.load_type}</td>
                        <td>{value.origin_state}</td>
                        <td>{value.origin_city}</td>
                        <td>{value.origin_address}</td>
                        <td>{value.pickup_date}</td>
                        <td>{value.delivery_date}</td>
                        <td>{value.price_to_pay_carrier}</td>
                        <td>{value.status_value}</td>
                        <td>
                          <div className="multiple-btn offer-table-action-btn">
                            <Link
                              to={`/load-post/details/${value.id}`}
                              className="view-load-button"
                            >
                              <button>View</button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="no-load-post-data-text">
                      No Load Feed Data Available
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {seeMoreLoading && (
          <div className="loader d-flex justify-content-center mb-5 mt-5">
            <img style={{ width: "35px" }} src={LoaderImg} alt="" />
          </div>
        )}
      </div>
    </section>
  );
};

export default SipperLoadPostList;
